import { createSlice } from '@reduxjs/toolkit';

type Settings = {
  sidebar: {
    collapsed: boolean;
    overlayed: boolean;
  };
  accountMenu: {
    open: boolean;
    popup: boolean;
  };
};

const initialState: Settings = {
  sidebar: {
    collapsed: false,
    overlayed: false,
  },
  accountMenu: {
    open: false,
    popup: false,
  },
};

const SettingSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    toggleSidebarCollapsing(state) {
      state.sidebar.collapsed = !state.sidebar.collapsed;
    },
    startSidebarOverlaying(state) {
      state.sidebar.collapsed = false;
      state.sidebar.overlayed = true;
    },
    stopSidebarOverlaying(state) {
      state.sidebar.overlayed = false;
    },
    toggleAccountMenuOpen(state) {
      state.accountMenu.open = !state.accountMenu.open;
    },
    openAccountMenu(state) {
      state.accountMenu.open = true;
    },
    toggleAccountMenuPopup(state) {
      state.accountMenu.popup = !state.accountMenu.popup;
    },
    closeAccountMenuPopup(state) {
      state.accountMenu.popup = false;
    },
  },
});

export default SettingSlice;
export const {
  toggleSidebarCollapsing,
  startSidebarOverlaying,
  stopSidebarOverlaying,
  toggleAccountMenuOpen,
  openAccountMenu,
  toggleAccountMenuPopup,
  closeAccountMenuPopup,
} = SettingSlice.actions;
